/**
 * Typ události mapového editoru.
 */
export enum EditorEventType {
    /**
     * Vytvoření feature.
     */
    CREATE = 'CREATE',

    /**
     * Aktualizace features.
     */
    UPDATE = 'UPDATE',

    /**
     * Smazání features.
     */
    DELETE = 'DELETE',

    /**
     * Změna výběru features.
     */
    SELECT = 'SELECT',

    /**
     * Export dat z mapy.
     */
    EXPORT = 'EXPORT',

    /**
     * Vykonání akce nad feature.
     */
    ACTION = 'ACTION',

    /**
     * Vykonání akce nástroje typu {@link EditorToolType.CUSTOM_ACTION}.
     */
    CUSTOM_ACTION = 'CUSTOM_ACTION',

    /**
     * Dočasná editace read-only feature spuštěna.
     */
    TEMP_EDITING_STARTED = 'TEMP_EDITING_STARTED',

    /**
     * Dočasná editace read-only feature dokončena.
     */
    TEMP_EDITING_FINISHED = 'TEMP_EDITING_FINISHED',

    /**
     * Získání aktuální pozice pomocí geolokace.
     */
    GEOLOCATION = 'GEOLOCATION',

    /**
     * Nástroj byl aktivován.
     */
    TOOL_ACTIVATED = 'TOOL_ACTIVATED',

    /**
     * Nástroj byl deaktivován.
     */
    TOOL_DEACTIVATED = 'TOOL_DEACTIVATED',

    /**
     * Interakce uživatele s mapou.
     */
    MAP_INTERACTION = 'MAP_INTERACTION',

    /**
     * Byl změněn topic
     */
    TOPIC_CHANGE = 'TOPIC_CHANGE',
}
